export default __webpack_public_path__ + "static/media/Icon_Details.757d4915.svg";